import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useNavigate } from "react-router-dom";
import ExportIcon from "../../../../../../assets/svg/ExportIcon";
import UserIcon from "../../../../../../assets/svg/UserIcon";
import Pagination from "../../../../../../components/Pagination/Pagination";
import KomentarModal from "../../../../../evidencija/components/Supervizije/Accordions/KomentarModal/KomentarModal";
import styles from "./Table.module.css";
import { extractGroupsPerApplication, formatData } from "./utils";

const Table = ({ dataLive, selectedProgram, selectedApplicationStatus }) => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [selectedText, setSelectedText] = useState("");
  const [readOnly, setReadOnly] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [polaznik, setPolaznik] = useState("");
  const itemsPerPage = 10;
  const safeData = Array.isArray(dataLive) ? dataLive : [];
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentUsers = safeData.slice(indexOfFirstItem, indexOfLastItem);
  const grupa = extractGroupsPerApplication(dataLive);
  useEffect(() => {
    setCurrentPage(1);
  }, [selectedProgram, selectedApplicationStatus]);

  const currentUsersWithGroups = currentUsers.map((user) => {
    const userGroup = grupa.find(
      (groupData) => groupData.applicationId === user.id
    );
    return {
      ...user,
      validGroup: userGroup ? userGroup.group : null,
    };
  });
  const modifiedData = safeData.map((user) => {
    const userGroup = grupa.find(
      (groupData) => groupData.applicationId === user.id
    );
    return {
      ...user,
      validGroup: userGroup ? userGroup.group : null,
    };
  });
  const allUsersForExportByProgram = formatData(
    modifiedData?.sort((a, b) =>
      (a.User?.programCity || "").localeCompare(b.User?.programCity || "")
    )
  );
  return (
    <div className={styles.container}>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr className={styles.tableHeaderRow}>
              <th className={styles.nameSurnameHeaderCell}>
                <p className={styles.headerCellLabel}>Ime i prezime</p>
              </th>
              <th className={styles.linkHeaderCell}>
                <p className={styles.headerCellLabel}>
                  Aplikacije za{" "}
                  {selectedProgram === "3,4,5,6,7,8,9,10"
                    ? "OR/eOR"
                    : selectedProgram === "11,12"
                      ? "TT"
                      : selectedProgram === "13"
                        ? "TP1"
                        : selectedProgram === "14"
                          ? "TP2"
                          : "sve"}
                </p>
              </th>
              <th className={styles.descriptionHeaderCell}>
                <p className={styles.headerCellLabel}>Grupa</p>
              </th>{" "}
              {selectedProgram === "11,12" && (
                <th className={styles.descriptionHeaderCell}>
                  <p className={styles.headerCellLabel}>Evaluacija voditelja</p>
                </th>
              )}
              {selectedProgram === "3,4,5,6,7,8,9,10" && (
                <th className={styles.descriptionHeaderCell}>
                  <p className={styles.headerCellLabel}>Evaluacija voditelja</p>
                </th>
              )}
              {(selectedProgram === "13" || selectedProgram === "14") && (
                <th className={styles.descriptionHeaderCell}>
                  <p className={styles.headerCellLabel}>Evaluacija voditelja</p>
                </th>
              )}
              <th>
                <p className={styles.headerCellLabel}>Komentar</p>
              </th>
              {selectedProgram === "11,12" && (
                <th className={styles.descriptionHeaderCell}>
                  <p className={styles.headerCellLabel}>Status aplikacije</p>
                </th>
              )}
              {selectedProgram === "3,4,5,6,7,8,9,10" && (
                <th className={styles.descriptionHeaderCell}>
                  <p className={styles.headerCellLabel}>Status aplikacije</p>
                </th>
              )}
              {(selectedProgram === "13" || selectedProgram === "14") && (
                <th className={styles.descriptionHeaderCell}>
                  <p className={styles.headerCellLabel}>Status aplikacije</p>
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {currentUsersWithGroups
              ?.sort((a, b) =>
                (a.User?.programCity || "").localeCompare(
                  b.User?.programCity || ""
                )
              )
              .map((item, index) => (
                <tr
                  className={styles.tableDataRow}
                  key={index}
                  style={{
                    backgroundColor: item?.isReferadaAccepted
                      ? "#E8FEE8"
                      : item?.isReferadaAccepted === false
                        ? "#FEE8E8"
                        : "",
                  }}
                >
                  <td
                    className={styles.nameSurnameCell}
                    onClick={() =>
                      navigate(`/pojedini-polaznik/${item.User.id}`)
                    }
                  >
                    {item.User.imageUrl === "" ? (
                      <div className={styles.emptyProfilePhoto}>
                        <UserIcon className={styles.profilePhotoIcon} />
                      </div>
                    ) : (
                      <img
                        alt="user"
                        src={item.User.imageUrl}
                        className={styles.userPhoto}
                      />
                    )}
                    <div
                      className={styles.nameSurnameContainer}
                      onClick={() =>
                        navigate(`/pojedini-polaznik/${item.User.id}`)
                      }
                    >
                      <p>{item.User.firstName}</p>
                      <p>{item.User.lastName}</p>
                    </div>
                  </td>
                  <td className={styles.tableLinkCell}>
                    <p
                      onClick={() =>
                        navigate(
                          `/dokumenti/aplikacije-za-upis/anketa/${item.id}`
                        )
                      }
                      className={styles.tableLinkText}
                    >
                      Uvid u aplikaciju
                    </p>
                  </td>
                  <td
                    className={styles.tableLinkCell}
                    onClick={() => {
                      if (item?.validGroup.id) {
                        navigate(`/grupe/${item?.validGroup.id}`);
                      }
                    }}
                  >
                    <p className={styles.tableLinkText}>
                      {item?.validGroup?.name}
                    </p>
                  </td>
                  {selectedProgram === "11,12" && (
                    <td className={styles.tableSupervisorCell}>
                      <p className={styles.tableSupervisorText}>
                        {item.isMentorAccepted === null
                          ? "------"
                          : item.isMentorAccepted === true
                            ? `Odobreno`
                            : `Nije odobreno`}
                      </p>
                    </td>
                  )}
                  {(selectedProgram === "3,4,5,6,7,8,9,10" ||
                    selectedProgram === "13" ||
                    selectedProgram === "14") && (
                    <td className={styles.tableSupervisorCell}>
                      <p className={styles.tableSupervisorText}>
                        {item.isMentorAccepted === null
                          ? "------"
                          : item.isMentorAccepted === true
                            ? `Odobreno`
                            : `Nije odobreno`}
                      </p>
                    </td>
                  )}

                  <td>
                    <p className={styles.tableSupervisorText}>
                      {item?.mentorReview ? (
                        <>
                          <span
                            style={{
                              cursor:
                                item?.mentorReview?.length > 100
                                  ? "pointer"
                                  : "not-allowed",
                              textDecoration:
                                item?.mentorReview?.length > 100
                                  ? "underline"
                                  : "",
                              pointerEvents:
                                item?.mentorReview?.length < 100
                                  ? "none"
                                  : undefined,
                            }}
                            className={styles.comment}
                            onClick={() => {
                              setPolaznik(
                                `${item?.User.firstName} ${item?.User.lastName}`
                              );
                              setSelectedText(item?.mentorReview);
                              setReadOnly(true);
                              setShowModal(true);
                            }}
                          >
                            {item?.mentorReview}
                          </span>
                        </>
                      ) : (
                        <span className={styles.tableSupervisorText}>
                          ------
                        </span>
                      )}
                    </p>
                  </td>
                  {selectedProgram === "11,12" && (
                    <td className={styles.tableSupervisorCell}>
                      <p className={styles.tableSupervisorText}>
                        {item.isReferadaAccepted === null
                          ? "------"
                          : item.isReferadaAccepted === true
                            ? `Odobreno`
                            : `Nije odobreno`}
                      </p>
                    </td>
                  )}
                  {(selectedProgram === "3,4,5,6,7,8,9,10" ||
                    selectedProgram === "13" ||
                    selectedProgram === "14") && (
                    <td className={styles.tableSupervisorCell}>
                      <p className={styles.tableSupervisorText}>
                        {item.isReferadaAccepted === null
                          ? "------"
                          : item.isReferadaAccepted === true
                            ? `Odobreno`
                            : `Nije odobreno`}
                      </p>
                    </td>
                  )}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      <Pagination
        itemsToDisplay={dataLive}
        setCurrent={setCurrentPage}
        currentPage={currentPage}
        customWidth={"100%"}
        itemsPerPage={itemsPerPage}
      />
      {Object.entries(allUsersForExportByProgram || {}).map(
        ([groupName, groupData]) =>
          groupData.length > 0 ? (
            <CSVLink
              key={groupName}
              data={groupData.map((row, index) => ({
                "Br.": index + 1,
                ...row,
              }))}
              target="_blank"
              filename={`Aplikacije_${groupName}.csv`}
              className={styles.exportButton}
            >
              <p className={styles.exportButtonText}>
                Export odgovora za {groupName}
              </p>
              <ExportIcon className={styles.exportButtonIcon} />
            </CSVLink>
          ) : null
      )}

      {showModal && (
        <KomentarModal
          onClose={() => setShowModal(false)}
          commentText={selectedText}
          readOnly={readOnly}
          isApplicationReferada
          polaznik={polaznik}
          selectedProgram={selectedProgram}
        />
      )}
    </div>
  );
};
export default Table;
